import React from 'react'
import { useSelector } from 'react-redux'
import { useIntercom } from 'react-use-intercom'

import styles from './HomeContent.module.scss'

import SubscriptionInfo from 'components/modules/settings/SubscriptionsInfo'
import PromoBlock from 'components/elements/blocks/PromoBlock'
import ProductCard from 'components/modules/pricing/ProductCard'
import { Server as ProxyIcon, FolderOpen as FolderIcon } from 'components/icons'

import {
  selectUserSubscriptionView,
  selectUserProxyView,
} from 'store/user/selectors'
import { workingSubscriptionStatuses } from 'utils/constants'

const HomeContent: React.FC = () => {
  const { show } = useIntercom()

  const subscriptionInfo = useSelector(selectUserSubscriptionView)
  const userProxyInfo = useSelector(selectUserProxyView)

  const handleSupport = () => {
    show()
  }

  const products = [
    {
      title: 'Proxies',
      icon: <ProxyIcon />,
      description: 'Flexible proxy setup',
      features: [
        'Residential, mobile and USA datacenter proxies',
        'IPs in all countries (195+)',
      ],
      link: '/proxy',
      status: userProxyInfo?.status,
      btnLabel: 'proxies',
    },
  ]

  const productsList = products.map((product, index) => (
    <ProductCard
      product={product}
      isFullFunctional={
        workingSubscriptionStatuses.indexOf(subscriptionInfo?.status) >= 0
      }
      isDemoModeAvailable={!subscriptionInfo?.status}
      className={styles.productCard}
      key={`home-page-product-card_${index}`}
    />
  ))

  return (
    <div className={styles.container}>
      {!subscriptionInfo?.plan && (
        <PromoBlock
          title={'Welcome to new SOAX'}
          image={`${process.env.PUBLIC_URL}/ball.png`}
          className={styles.block}
        >
          Congratulations! You’ve been granted early access to our new dashboard
          beta, featuring the <b>Pay as you go</b> plan. Our Customer Care team is{' '}
          <span onClick={handleSupport} className={styles.supportLink}>
            here to assist you
          </span>{' '}
          at any time!
        </PromoBlock>
      )}

      <SubscriptionInfo />

      <div className={styles.row}>{productsList}</div>
    </div>
  )
}

export default HomeContent
